import React, { useState } from "react";
import { Link } from "react-router-dom";
import "./Haggling.css";

// Success Modal Component
const SuccessModal = ({ isOpen, onClose }) => {
  if (!isOpen) return null;
  
  return (
    <div className="haggling-modal-overlay">
      <div className="haggling-modal">
        <div className="haggling-modal-header">
          <h3>Success</h3>
          <button className="haggling-modal-close" onClick={onClose}>×</button>
        </div>
        <div className="haggling-modal-content">
          <div className="haggling-success-icon">
            <svg width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
              <circle cx="32" cy="32" r="32" fill="#F0FFEA" />
              <path d="M44 24L28 40L20 32" stroke="#16A34A" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
          </div>
          <p className="haggling-success-message">
            Congratulations! Both you and the seller have agreed on a final price.
          </p>
          <button className="haggling-modal-button" onClick={onClose}>Close</button>
        </div>
      </div>
    </div>
  );
};

export default function Haggling() {
  const [showFirstExpanded, setShowFirstExpanded] = useState(true);
  const [showModal, setShowModal] = useState(false);

  return (
    <div className="haggling-container">
      {/* Schedule Card */}
      <div className="haggling-schedule-card">
        <div className="haggling-header">
          <h2 className="haggling-title">My Schedule</h2>
          <div className="haggling-search">
            <input type="text" placeholder="Search Resource" />
            <svg className="haggling-search-icon" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M17.5 17.5L12.5 12.5M14.1667 8.33333C14.1667 11.555 11.555 14.1667 8.33333 14.1667C5.11167 14.1667 2.5 11.555 2.5 8.33333C2.5 5.11167 5.11167 2.5 8.33333 2.5C11.555 2.5 14.1667 5.11167 14.1667 8.33333Z" stroke="#667085" strokeWidth="1.66667" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
          </div>
        </div>

        <div className="haggling-schedule-list">
          {/* First item (expanded with details) */}
          <div className={`haggling-schedule-item ${showFirstExpanded ? 'expanded' : ''}`}>
            {showFirstExpanded && (
              <button className="haggling-show-less" onClick={() => setShowFirstExpanded(false)}>
                Show Less
              </button>
            )}
            
            <div className="haggling-schedule-content">
              <div className="haggling-left-column">
                <div className="haggling-date-group">
                  <div className="haggling-label">Date</div>
                  <div className="haggling-value">21 Nov 2024</div>
                </div>
                
                <div className="haggling-date-group">
                  <div className="haggling-label">Time</div>
                  <div className="haggling-value">1:00 PM</div>
                </div>
                
                {showFirstExpanded && (
                  <div className="haggling-date-group">
                    <div className="haggling-label">West African Time</div>
                    <div className="haggling-value">GMT +1</div>
                  </div>
                )}
              </div>
              
              <div className="haggling-middle-column">
                <div className="haggling-label">Information</div>
                <div className="haggling-vessel-name">ASG TUG NAVIGATOR</div>
                
                {showFirstExpanded && (
                  <div className="haggling-remaining-time">30 minutes remaining</div>
                )}
                
                <div className="haggling-vessel-details">
                  <div className="haggling-vessel-type">
                    <div className="haggling-label">Vessel Type</div>
                    <div className="haggling-value">AHTS 001</div>
                  </div>
                  
                  {showFirstExpanded && (
                    <div className="haggling-vessel-price">
                      <div className="haggling-label">Starting Price</div>
                      <div className="haggling-value">$10,000</div>
                    </div>
                  )}
                </div>
              </div>
              
              <div className="haggling-right-column">
                <Link to="/dashboard/haggling/bidding" className="haggling-join-button">Join Meeting</Link>
                
                {showFirstExpanded ? (
                  <button className="haggling-show-detail">Show Detail</button>
                ) : (
                  <button className="haggling-show-detail" onClick={() => setShowFirstExpanded(true)}>
                    Show Detail
                  </button>
                )}
              </div>
            </div>
          </div>
          
          {/* Second item */}
          <div className="haggling-schedule-item">
            <div className="haggling-schedule-content">
              <div className="haggling-left-column">
                <div className="haggling-date-group">
                  <div className="haggling-label">Date</div>
                  <div className="haggling-value">21 Nov 2024</div>
                </div>
                
                <div className="haggling-date-group">
                  <div className="haggling-label">Time</div>
                  <div className="haggling-value">1:00 PM</div>
                </div>
              </div>
              
              <div className="haggling-middle-column">
                <div className="haggling-label">Information</div>
                <div className="haggling-vessel-name">ASG TUG NAVIGATOR</div>
                
                <div className="haggling-vessel-details">
                  <div className="haggling-vessel-type">
                    <div className="haggling-label">Vessel Type</div>
                    <div className="haggling-value">AHTS 001</div>
                  </div>
                </div>
              </div>
              
              <div className="haggling-right-column">
                <Link to="/dashboard/haggling/bidding" className="haggling-join-button">Join Meeting</Link>
              </div>
            </div>
          </div>
          
          {/* Third item */}
          <div className="haggling-schedule-item">
            <div className="haggling-schedule-content">
              <div className="haggling-left-column">
                <div className="haggling-date-group">
                  <div className="haggling-label">Date</div>
                  <div className="haggling-value">21 Nov 2024</div>
                </div>
                
                <div className="haggling-date-group">
                  <div className="haggling-label">Time</div>
                  <div className="haggling-value">1:00 PM</div>
                </div>
              </div>
              
              <div className="haggling-middle-column">
                <div className="haggling-label">Information</div>
                <div className="haggling-vessel-name">ASG TUG NAVIGATOR</div>
                
                <div className="haggling-vessel-details">
                  <div className="haggling-vessel-type">
                    <div className="haggling-label">Vessel Type</div>
                    <div className="haggling-value">AHTS 001</div>
                  </div>
                </div>
              </div>
              
              <div className="haggling-right-column">
                <Link to="/dashboard/haggling/bidding" className="haggling-join-button">Join Meeting</Link>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* Success Modal */}
      <SuccessModal isOpen={showModal} onClose={() => setShowModal(false)} />
    </div>
  );
} 